import React, { useEffect, useState } from "react";
import { Coins, Clock, ShieldCheck, Info, CheckCircle, Medal } from "@phosphor-icons/react";
import api from "../api";
import { BadgeGrid } from "./Sponsors";

export default function Earn() {
  React.useEffect(() => { import("../api").then((m) => m.track("earn_page_view")); }, []);
  const [data, setData] = useState(null);
  const [badges, setBadges] = useState(null);

  useEffect(() => {
    api.get("/commissioned/player").then((r) => setData(r.data)).catch(() => {});
    api.get("/commissioned/badges/player").then((r) => setBadges(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="earn-page">
      <div className="flex flex-wrap items-center gap-3">
        <Coins size={26} weight="duotone" className="text-ff-gold" />
        <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">{data?.title || "Earn Through Expeditions"}</h1>
        <span data-testid="earn-coming-later-badge" className="inline-flex items-center gap-1 rounded-full border border-ff-brass/40 px-3 py-1 text-xs uppercase tracking-widest text-ff-brass">
          <Clock size={13} /> {data?.badge || "Coming Later"}
        </span>
      </div>

      <p className="text-lg text-ff-gold" data-testid="earn-tagline">{data?.tagline}</p>

      <div className="ff-panel rounded-md p-5" data-testid="earn-not-available">
        <div className="flex items-start gap-2">
          <Info size={20} weight="duotone" className="mt-0.5 shrink-0 text-ff-brass" />
          <p className="text-base leading-relaxed text-ff-parchment/90">{data?.intro}</p>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="ff-panel rounded-md p-5">
          <h2 className="text-lg font-semibold text-ff-gold">How it will work</h2>
          <ul className="mt-3 space-y-2" data-testid="earn-how">
            {(data?.how_it_will_work || []).map((h, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-ff-parchment/90">
                <CheckCircle size={16} weight="duotone" className="mt-0.5 shrink-0 text-ff-brass" /> {h}
              </li>
            ))}
          </ul>
        </div>

        <div className="ff-panel rounded-md p-5">
          <h2 className="flex items-center gap-2 text-lg font-semibold text-ff-gold">
            <ShieldCheck size={20} weight="duotone" /> Important disclosures
          </h2>
          <ul className="mt-3 space-y-2" data-testid="earn-disclosures">
            {(data?.important_disclosures || []).map((d, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-ff-muted">
                <span className="mt-1 text-ff-brass">◆</span> {d}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="rounded-md border border-ff-brass/30 bg-ff-bg2 p-5 text-center" data-testid="earn-inactive-note">
        <p className="text-sm text-ff-muted">
          This feature is <span className="font-semibold text-ff-parchment">not currently active</span>. No payment or reward is
          available today, and your virtual Gold has no cash value.
        </p>
      </div>

      {badges && (
        <div className="ff-panel rounded-md p-5" data-testid="earn-badges-section">
          <h2 className="flex items-center gap-2 text-lg font-semibold text-ff-gold">
            <Medal size={20} weight="duotone" /> {badges.title}
            <span data-testid="earn-badges-coming-later" className="ml-1 rounded-full border border-ff-brass/40 px-2 py-0.5 text-[10px] uppercase tracking-widest text-ff-brass">{badges.badge}</span>
          </h2>
          <p className="mt-2 text-sm text-ff-muted">{badges.intro}</p>
          <div className="mt-4 grid gap-3 md:grid-cols-2">
            <ul className="space-y-1.5" data-testid="earn-badge-controls">
              {(badges.your_controls || []).map((c, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-ff-parchment/90">
                  <CheckCircle size={16} weight="duotone" className="mt-0.5 shrink-0 text-ff-brass" /> {c}
                </li>
              ))}
            </ul>
            <ul className="space-y-1.5" data-testid="earn-badge-important">
              {(badges.important || []).map((c, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-ff-muted"><span className="mt-1 text-ff-brass">◆</span> {c}</li>
              ))}
            </ul>
          </div>
          <div className="mt-5"><BadgeGrid badges={badges.preview_badges} testid="earn-badge-grid" /></div>
        </div>
      )}
    </div>
  );
}
